import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const OsGeneric = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.094 22.416c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m-7.57-10.005c0 2.475 1.53 4.136 3.905 4.136s3.905-1.662 3.905-4.136-1.529-4.125-3.905-4.125-3.905 1.65-3.905 4.125m6.182 0c0 1.87-1.034 2.882-2.277 2.882S6.152 14.28 6.152 12.41 7.186 9.54 8.43 9.54s2.277 1 2.277 2.87m2.5-1.815c0 1.386 1.088 2.057 2.386 2.31l1.012.186c.847.154 1.474.407 1.474 1.09 0 .857-.89 1.11-1.595 1.11-.946 0-1.76-.351-1.936-1.517H13.03c.143 1.716 1.441 2.772 3.4 2.772 1.605 0 3.233-.804 3.233-2.443 0-1.65-1.43-2.166-2.728-2.397l-1.045-.187c-.638-.121-1.11-.43-1.11-.99 0-.715.813-.99 1.54-.99.747 0 1.561.308 1.682 1.243h1.518c-.077-1.53-1.485-2.497-3.135-2.497-1.474 0-3.179.704-3.179 2.31'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.094 22.416c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m-7.57-10.005c0 2.475 1.53 4.136 3.905 4.136s3.905-1.662 3.905-4.136-1.529-4.125-3.905-4.125-3.905 1.65-3.905 4.125m6.182 0c0 1.87-1.034 2.882-2.277 2.882S6.152 14.28 6.152 12.41 7.186 9.54 8.43 9.54s2.277 1 2.277 2.87m2.5-1.815c0 1.386 1.088 2.057 2.386 2.31l1.012.186c.847.154 1.474.407 1.474 1.09 0 .857-.89 1.11-1.595 1.11-.946 0-1.76-.351-1.936-1.517H13.03c.143 1.716 1.441 2.772 3.4 2.772 1.605 0 3.233-.804 3.233-2.443 0-1.65-1.43-2.166-2.728-2.397l-1.045-.187c-.638-.121-1.11-.43-1.11-.99 0-.715.813-.99 1.54-.99.747 0 1.561.308 1.682 1.243h1.518c-.077-1.53-1.485-2.497-3.135-2.497-1.474 0-3.179.704-3.179 2.31'
        fill='currentColor'
      />
    )}
  </IconBase>
);
